import e from "./SchemaGlyphPuck.vue.js";
import { createElementBlock as t, createVNode as n, defineComponent as r, openBlock as i } from "vue";
//#region src/schema/SchemaGutterToggle.vue?vue&type=script&setup=true&lang.ts
var a = [
	"aria-controls",
	"aria-describedby",
	"aria-expanded",
	"aria-label",
	"aria-labelledby"
], o = /*@__PURE__*/ r({
	__name: "SchemaGutterToggle",
	props: {
		open: { type: Boolean },
		panelId: {},
		panelRendered: { type: Boolean },
		nameId: {},
		fallbackLabel: {},
		countId: {}
	},
	emits: ["toggle"],
	setup(r, { emit: o }) {
		let s = o;
		return (o, c) => (i(), t("button", {
			"aria-controls": r.panelRendered ? r.panelId : void 0,
			"aria-describedby": r.countId,
			"aria-expanded": r.open,
			"aria-label": r.nameId ? void 0 : r.fallbackLabel,
			"aria-labelledby": r.nameId,
			class: "property-toggle group/tree-control flex size-[var(--schema-toggle-size,24px)] shrink-0 cursor-pointer items-center justify-center rounded-[999px] border-none bg-transparent p-0 text-[color:var(--schema-glyph-color,var(--scalar-color-2))]",
			"data-schema-toggle": "",
			type: "button",
			onClick: c[0] ||= (e) => s("toggle")
		}, [n(e, {
			class: "property-glyph",
			floating: !1,
			open: r.open
		}, null, 8, ["open"])], 8, a));
	}
});
//#endregion
export { o as default };

//# sourceMappingURL=SchemaGutterToggle.vue_vue_type_script_setup_true_lang.js.map